/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiBatchUpdateOrgStructureByFilterRequest,
  ApiBatchUpdateOrgStructureByIdsRequest,
  ApiBatchUpdateOrgStructureRequest,
  BatchUpdateOrgStructureResponse,
  OtpCodeRequest,
  OtpCodeResponseDto,
  RegisterUserPhoneRequest,
  UpdateOrgStructureDto,
  UserDto,
  UserProfileDto,
  UserProfileSlim,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiUserController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-user-controller
   * @name UpdateUserPhone
   * @request PUT:/api/v1/users/{userId}/phone
   */
  updateUserPhone = (userId: string, data: RegisterUserPhoneRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/users/${userId}/phone`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateUserPhonePath = '/v1/users/${userId}/phone'
  static updateUserPhoneMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name ConfirmPhone
   * @request PUT:/api/v1/users/{userId}/phone/confirm
   */
  confirmPhone = (userId: string, data: OtpCodeRequest, params: RequestParams = {}) =>
    this.http.request<UserDto, any>({
      path: `/v1/users/${userId}/phone/confirm`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static confirmPhonePath = '/v1/users/${userId}/phone/confirm'
  static confirmPhoneMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name UpdateOrgStructure
   * @request PUT:/api/v1/users/{userId}/org-structure
   */
  updateOrgStructure = (userId: string, data: UpdateOrgStructureDto, params: RequestParams = {}) =>
    this.http.request<UserProfileDto, any>({
      path: `/v1/users/${userId}/org-structure`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrgStructurePath = '/v1/users/${userId}/org-structure'
  static updateOrgStructureMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name UpdateOrgStructureBatch
   * @request PUT:/api/v1/users/org-structure/batch
   */
  updateOrgStructureBatch = (data: ApiBatchUpdateOrgStructureRequest, params: RequestParams = {}) =>
    this.http.request<BatchUpdateOrgStructureResponse, any>({
      path: `/v1/users/org-structure/batch`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrgStructureBatchPath = '/v1/users/org-structure/batch'
  static updateOrgStructureBatchMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name UpdateOrgStructureBatchByIds
   * @request PUT:/api/v1/users/org-structure/batch-by-ids
   */
  updateOrgStructureBatchByIds = (
    data: ApiBatchUpdateOrgStructureByIdsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<BatchUpdateOrgStructureResponse, any>({
      path: `/v1/users/org-structure/batch-by-ids`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrgStructureBatchByIdsPath = '/v1/users/org-structure/batch-by-ids'
  static updateOrgStructureBatchByIdsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name UpdateOrgStructureBatchByFilter
   * @request PUT:/api/v1/users/org-structure/batch-by-filter
   */
  updateOrgStructureBatchByFilter = (
    data: ApiBatchUpdateOrgStructureByFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<BatchUpdateOrgStructureResponse, any>({
      path: `/v1/users/org-structure/batch-by-filter`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrgStructureBatchByFilterPath = '/v1/users/org-structure/batch-by-filter'
  static updateOrgStructureBatchByFilterMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name RequestOtp
   * @request POST:/api/v1/users/{userId}/request-otp
   */
  requestOtp = (userId: string, params: RequestParams = {}) =>
    this.http.request<OtpCodeResponseDto, any>({
      path: `/v1/users/${userId}/request-otp`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static requestOtpPath = '/v1/users/${userId}/request-otp'
  static requestOtpMethod = 'POST'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name RequestPhoneConfirmation
   * @request POST:/api/v1/users/{userId}/phone/request-confirmation
   */
  requestPhoneConfirmation = (userId: string, params: RequestParams = {}) =>
    this.http.request<OtpCodeResponseDto, any>({
      path: `/v1/users/${userId}/phone/request-confirmation`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static requestPhoneConfirmationPath = '/v1/users/${userId}/phone/request-confirmation'
  static requestPhoneConfirmationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-user-controller
   * @name GetUserProfilesSlim
   * @request GET:/api/v1/user-profile/slim
   */
  getUserProfilesSlim = (params: RequestParams = {}) =>
    this.http.request<UserProfileSlim[], any>({
      path: `/v1/user-profile/slim`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getUserProfilesSlimPath = '/v1/user-profile/slim'
  static getUserProfilesSlimMethod = 'GET'
}
